import { CanActivateFn } from '@angular/router';

export const jvDashboardRedirectGuard: CanActivateFn = () => {
  return true;
};
